import {FC, useCallback} from "react";
import Box from "@mui/material/Box"
import BaseCard from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Typography from "@mui/material/Typography"
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {Plan} from "@memaro/api";
import {PlanDefinition} from "../../../constants/profile.ts";
import styled from "@emotion/styled";
import {formatMoney} from "../../../lib/money.ts";

export type CardProps = {
    plan: PlanDefinition;
    disabled?: boolean;
    onClick: (plan: Plan) => void;
    isSelected?: boolean;
}

type StyledCardProps = Pick<CardProps, 'disabled' | 'isSelected'>

const StyledCard = styled(BaseCard)<StyledCardProps>(({disabled, isSelected}) => ({
    minWidth: 200,
    flexGrow: 1,
    flexBasis: 0,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: '0.3s',
    background: isSelected ? 'white' : '#E9E8E6',
    m: 2,
    color: disabled ? "gray" : "black"
}))

const Card: FC<CardProps> = ({plan, disabled, onClick, isSelected}) => {
    const handleClick = useCallback(() => {
        if (!disabled) {
            onClick(plan.plan)
        }
    }, [disabled, onClick, plan.plan])

    return (
        <StyledCard onClick={handleClick} elevation={isSelected ? 5 : 3} disabled={disabled} isSelected={isSelected}>
            <Box
                sx={{
                    backgroundColor: plan.color,
                    p: 2,
                    textAlign: 'center',
                }}
            >
                <Typography variant="h6" color="white" fontWeight="bold">
                    {plan.title}
                </Typography>
            </Box>
            <CardContent sx={{textAlign: 'center'}}>
                <Typography variant="h4" fontWeight="bold">
                    {formatMoney(plan.price, 0)}
                </Typography>
                <Typography variant="subtitle1" sx={{mb: 2}}>
                    / jaar
                </Typography>
                <List>
                    {plan.features.map((feature, index) => (
                        <ListItem key={index}>
                            <ListItemIcon>
                                <CheckCircleIcon color="success"/>
                            </ListItemIcon>
                            <ListItemText primary={feature}/>
                        </ListItem>
                    ))}
                </List>
            </CardContent>
        </StyledCard>
    )
}

export default Card
